export default __webpack_public_path__ + "static/media/month-report.fe56eb21.png";